export const HORSE_INFO_POPUP = 'HORSE_INFO_POPUP';
export const RACE_ANALYSIS_POPUP = 'RACE_ANALYSIS_POPUP';
export const OWN_PROFIT_EVALUATION_POPUP = 'OWN_PROFIT_EVALUATION_POPUP';
